/**
 * Normalize a category string so comparisons/grouping are consistent.
 *
 * Rules:
 * - trims leading/trailing whitespace
 * - lowercases
 * - strips all whitespace
 * - strips special characters (keeps only a-z, 0-9, underscore)
 */
export function normalizeCategory(input: string | undefined | null): string {
  if (!input) return ''
  return input
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9_]/g, '')
}

/**
 * Format a normalized category for display.
 *
 * Example: "inspection_walkdown_report" -> "Inspection Walkdown Report"
 */
export function formatCategory(normalizedCategory: string): string {
  const raw = normalizedCategory.trim()
  if (!raw) return 'Unknown'

  return raw
    .split('_')
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase() + part.slice(1))
    .join(' ')
}
